export default __webpack_public_path__ + "static/media/back-arrow.e7b856b3.svg";